<template>
<main>
  <div class="item">
    <heading>Applicant</heading>
    <user-card :user="applicant" />
  </div>
  <div class="item">
  <heading>Agreed salary</heading>
  <currency-field v-model="salary" />
  </div>
  <div class="item">
    <heading>Start date</heading>
    <date-picker placeholder="Start date" v-model="startDate" />
  </div>
  <divider />
  <div class="item">
    <heading>Total cost</heading>
    <div v-if="salary">
      <p>
      If the applicant accepts your job offer of <b>${{ parseFloat(salary).toLocaleString() }}</b>,
      your total HireVibes invoice, to be paid in USD, will cost:
      </p>
      <div class="hvt-reward">
        <h1 class="title">
          ${{ totalReward.toLocaleString() }}
        </h1>
      </div>
    </div>
    <p v-else>
    Please enter your offered salary
    </p>
  </div>
</main>
</template>

<script>
import { mapState, mapMutations, mapGetters, mapActions } from 'vuex'
import UserCard from '@/components/general/user-row-card'
import Heading from '@/components/general/heading'
import CurrencyField from '@/components/general/currency-text-field'
import DatePicker from '@/components/general/date-picker'
import Divider from '@/components/general/divider'
import RewardHelper from '@/helpers/reward'

export default {
  components: { UserCard, Heading, CurrencyField, DatePicker, Divider },
  methods: {
    ...mapMutations('adminApplications', [
      'setCurrentOfferSalary',
      'setCurrentOfferStartDate'
    ]),
    ...mapActions('adminApplications', [
      'updatePrice'
    ])
  },
  computed: {
    ...mapState('adminApplications', [
      'current',
      'currentJob',
      'currentOfferSalary',
      'currentOfferStartDate',
      'currentPrice'
    ]),
    ...mapGetters('adminApplications', [
      'applicant',
      'hvtReward'
    ]),
    salary: {
      get () { return this.currentOfferSalary },
      set (value) { this.setCurrentOfferSalary(value) }
    },
    startDate: {
      get () { return this.currentOfferStartDate },
      set (value) { this.setCurrentOfferStartDate(value) }
    },
    tokenPrice () {
      return Number(this.currentPrice).toFixed(4)
    },
    totalReward () {
      return RewardHelper.totalReward(this.currentOfferSalary, this.currentJob.rewardPercentage)
    },
    userReward () {
      if (this.reward) {
        return this.reward.user
      }
      return 0
    },
    dacReward () {
      if (this.reward) {
        return this.reward.dac
      }
      return 0
    },
    charityReward () {
      if (this.reward) {
        return this.reward.charity
      }
      return 0
    }
  },
  data () {
    return {
      reward: null
    }
  },
  mounted () {
    this.reward = RewardHelper.calc(this.currentJob.rewardPercentage, this.totalReward)
    this.updatePrice()
  }
}
</script>

<style lang="scss" scoped>
@import '~@/styles/defaults.scss';

.item:not(:first-child) {
  margin-top: 1.5rem;
  line-height: 1.5rem;

  & /deep/ .field .control {
    margin-top: 0;
  }
}
.heading {
  margin-bottom: 0.5rem;
}
.hvt-reward {
  width: 100%;
  display: flex;
  align-items: center;
  padding-top: 1.5rem;
  flex-direction: column;

  font-size: 0.75rem;

  .title {
    font-size: 1.5rem;
    color: $black;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/applications/make-offer-form.vue